import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const transportRequestCreate = createAsyncThunk("transportRequestCreate", async ({ data }, { rejectWithValue }) => {
    try {
        console.log("data", data);
        const response = await axiosHttp.post(`requests/transport`, data);
        return response.data;

    } catch (err) {
        if (!err.response) {
            throw err;
        }
        return rejectWithValue(err.response.data);
    }
});

const transportRequestCreateSlice = createSlice({
    name: "transportRequestCreateSlice",
    initialState: {
        isLoading: false,
        isError: false,
        error: null,
        data: null,
    },

    reducers: {
        resetCreateState: (state) => {
            state.isLoading = false;
            state.error = false;
            state.data = null;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(transportRequestCreate.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(transportRequestCreate.fulfilled, (state, action) => {
            state.isLoading = false;
            state.isError = false;
            state.data = action.payload;
        });

        builder.addCase(transportRequestCreate.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action.payload;
        });
    },
});

export const { resetCreateState } = transportRequestCreateSlice.actions;
export default transportRequestCreateSlice.reducer;
